/* ── Waco Diamonds — collection card colour swatches (in-place image + link swap) ──
   One delegated click handler for all cards. Clicking a swatch swaps the card's featured
   image to the chosen colour child's hero and updates the card link so a click-through
   lands on that colour child. No navigation happens on the swatch click itself.
   Swatches are real <button>s, so Enter/Space activate them for keyboard users. */
(function () {
  'use strict';
  if (window.__wacoCardSwatches) return;
  window.__wacoCardSwatches = true;

  function activate(btn) {
    var card = btn.closest('.card-product');
    if (!card) return;

    // Swap the featured image (first image in the media wrapper).
    var img = card.querySelector('.card__media-wrapper img');
    var src = btn.getAttribute('data-image');
    var srcset = btn.getAttribute('data-srcset');
    if (img && src) {
      img.setAttribute('src', src);
      if (srcset) { img.setAttribute('srcset', srcset); } else { img.removeAttribute('srcset'); }
      img.removeAttribute('data-src');
      img.classList.add('loaded');
    }

    // Update the click-through link so it lands on the selected colour child.
    var href = btn.getAttribute('data-url');
    if (href) {
      var link = card.querySelector('.expand-link__link');
      if (link) link.setAttribute('href', href);
    }

    // Active state / aria.
    var all = card.querySelectorAll('[data-waco-card-swatch]');
    for (var i = 0; i < all.length; i++) {
      all[i].classList.toggle('is-active', all[i] === btn);
      if (all[i] === btn) { all[i].setAttribute('aria-current', 'true'); }
      else { all[i].removeAttribute('aria-current'); }
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-waco-card-swatch]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    activate(btn);
  });
})();
